export class WebhookV1StandardPayloadIssueMutedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "issueMutedNotificationArguments",
            "baseName": "issueMutedNotificationArguments",
            "type": "WebhookV1IssueMutedNotificationArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadIssueMutedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
